import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const OnlineAssist: React.FC = () => {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Animate progress bar
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 2;
      });
    }, 40); // 40ms * 50 steps = 2s total

    // Redirect after 2.2s
    const timeout = setTimeout(() => {
      navigate('/');
    }, 2200);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#FFFFFF',
      gap: '32px',
    }}>
      {/* Logo / Brand */}
      <div style={{ textAlign: 'center' }}>
        <div style={{
          fontSize: '40px',
          fontWeight: '800',
          color: '#111827',
          letterSpacing: '-1px',
          marginBottom: '8px',
        }}>
          industry<span style={{ color: '#81C862' }}>bull</span>
        </div>
        <div style={{ fontSize: '15px', color: '#6B7280' }}>
          Online Assist
        </div>
      </div>

      {/* Spinner */}
      <div style={{ position: 'relative', width: '72px', height: '72px' }}>
        <svg
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: '72px', height: '72px', animation: 'spin 1s linear infinite' }}
        >
          <circle cx="36" cy="36" r="30" stroke="#E5E7EB" strokeWidth="6" />
          <path
            d="M36 6a30 30 0 0 1 30 30"
            stroke="#4ABCE8"
            strokeWidth="6"
            strokeLinecap="round"
          />
        </svg>
        <style>{`
          @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        `}</style>
      </div>

      {/* Status text */}
      <div style={{ textAlign: 'center' }}>
        <p style={{ fontSize: '18px', fontWeight: '600', color: '#111827', margin: '0 0 6px 0' }}>
          Connecting you to Industrybull…
        </p>
        <p style={{ fontSize: '14px', color: '#6B7280', margin: 0 }}>
          You will be redirected to the home page shortly.
        </p>
      </div>

      {/* Progress bar */}
      <div style={{
        width: '280px',
        height: '6px',
        background: '#E5E7EB',
        borderRadius: '100px',
        overflow: 'hidden',
      }}>
        <div style={{
          height: '100%',
          width: `${progress}%`,
          background: 'linear-gradient(90deg, #4ABCE8, #81C862)',
          borderRadius: '100px',
          transition: 'width 0.04s linear',
        }} />
      </div>
    </div>
  );
};

export default OnlineAssist;
